import {
  GET_SHIPMENTCARRIER,
  GET_SHIPMENTCARRIER_SUCCESS,
  GET_SHIPMENTCARRIER_FAIL,
  DELETE_SHIPMENTCARRIER,
  DELETE_SHIPMENTCARRIER_SUCCESS,
  DELETE_SHIPMENTCARRIER_FAIL,
  UPDATE_SHIPMENTCARRIER,
  UPDATE_SHIPMENTCARRIER_SUCCESS,
  UPDATE_SHIPMENTCARRIER_FAIL,
  ADD_NEW_SHIPMENTCARRIER,
  ADD_SHIPMENTCARRIER_SUCCESS,
  ADD_SHIPMENTCARRIER_FAIL,
  SHIPMENTCARRIER_LOADING,
  SHIPMENTCARRIER_RESET,
} from "./actionType";

export const resetShipmentCarrierState = (actionType) => ({
  type: SHIPMENTCARRIER_RESET,
  payload: { actionType },
});

export const getShipmentCarrierSuccess = (actionType, data) => ({
  type: GET_SHIPMENTCARRIER_SUCCESS,
  payload: { actionType, data },
});

export const getShipmentCarrierFail = (actionType, error) => ({
  type: GET_SHIPMENTCARRIER_FAIL,
  payload: { actionType, error },
});

export const getShipmentCarrier = data => ({
  type: GET_SHIPMENTCARRIER,
  payload: data,
});

export const getShipmentCarrierLoading = () => ({
  type: SHIPMENTCARRIER_LOADING
});

export const deleteShipmentCarrier = data => ({
  type: DELETE_SHIPMENTCARRIER,
  payload: data,
});

export const deleteShipmentCarrierSuccess = data => ({
  type: DELETE_SHIPMENTCARRIER_SUCCESS,
  payload: data,
});

export const deleteShipmentCarrierFail = error => ({
  type: DELETE_SHIPMENTCARRIER_FAIL,
  payload: error,
});

export const updateShipmentCarrier = data => ({
  type: UPDATE_SHIPMENTCARRIER,
  payload: data,
});

export const updateShipmentCarrierFail = error => ({
  type: UPDATE_SHIPMENTCARRIER_FAIL,
  payload: error,
});

export const updateShipmentCarrierSuccess = data => ({
  type: UPDATE_SHIPMENTCARRIER_SUCCESS,
  payload: data,
});

export const addNewShipmentCarrier = data => ({
  type: ADD_NEW_SHIPMENTCARRIER,
  payload: data,
});

export const addShipmentCarrierSuccess = data => ({
  type: ADD_SHIPMENTCARRIER_SUCCESS,
  payload: data,
});

export const addShipmentCarrierFail = error => ({
  type: ADD_SHIPMENTCARRIER_FAIL,
  payload: error,
});